<template>
  <div v-if="hasAccess" class="level__resume">
    <template v-if="isLoading">
      <ActionLoader
        loaderClass="level__loading-spinner"
        name="ball-clip-rotate"
      />
    </template>
    <template v-else>
      <button
        v-if="isContentActive"
        v-on="$listeners"
        class="btn__large"
        id="stop"
      >
        Close
        <i class="btn__large-icon material-icons">stop</i>
      </button>
      <button
        v-else
        v-on="$listeners"
        :class="[
          'btn__large',
          !isContentFinished(status) && 'btn__large--alternate',
          statusText.length > 6 && 'btn__large--long',
        ]"
        id="state-control"
      >
        {{ statusText }}
        <i
          v-if="isContentFinished(status)"
          class="btn__large-icon btn__large-icon--alt material-icons"
          >replay</i
        >
        <PlayButtonIcon class="btn__large-icon" v-else />
      </button>
    </template>
  </div>
  <div v-else class="level__resume">
    <button
      v-if="canUpgradePlan && courseStatus !== 'coming soon'"
      @click="handlePlanUpgrade"
      class="btn__large level__access-btn"
      id="premium-upgrade"
    >
      GET ACCESS
      <LockIcon class="btn__large-icon level__access-btn--icon" />
    </button>
    <a
      v-else
      class="btn__large level__access-btn"
      :href="`//${plansLink}`"
      id="ine-link"
    >
      {{ courseStatus === 'coming soon' ? 'COMING SOON' : 'GET ACCESS' }}
      <LockIcon class="btn__large-icon level__access-btn--icon" />
    </a>
    <PremiumUpgradeModal
      v-if="isPremiumUpgradeModalShown"
      @toggle-premium-upgrade-modal="isPremiumUpgradeModalShown = false"
      :subscriptionId="planToBeUpgraded.id"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PremiumUpgradeModal from '@/components/modals/PremiumUpgradeModal.vue'
import PlayButtonIcon from '@/assets/icons/course/play-icon.svg'
import LockIcon from '@/assets/icons/course/lock_icon.svg'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'LevelControl',
  components: {
    PremiumUpgradeModal,
    PlayButtonIcon: { ...PlayButtonIcon, name: 'PlayButtonIcon' },
    LockIcon: { ...LockIcon, name: 'LockIcon' },
    ActionLoader,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    isContentActive: {
      type: Boolean,
      required: true,
    },
    statusText: {
      type: String,
      required: true,
    },
    hasAccess: {
      type: Boolean,
      required: true,
    },
    status: {
      type: String,
      required: false,
      default: CONSTANTS.CONTENT_USER_STATUS.UNSTARTED,
    },
    plansLink: {
      type: String,
      required: true,
    },
    courseStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      planToBeUpgraded: {},
      isPremiumUpgradeModalShown: false,
    }
  },
  computed: {
    ...mapGetters({
      usersSubscriptions: 'subscriptions/usersSubscriptions',
    }),
    canUpgradePlan() {
      const {
        usersSubscriptions: { personalPlans },
      } = this
      return !!(personalPlans && personalPlans.length)
    },
  },
  methods: {
    handlePlanUpgrade() {
      const {
        usersSubscriptions: { personalPlans },
      } = this
      this.planToBeUpgraded = personalPlans[0]
      this.isPremiumUpgradeModalShown = true
    },
    isContentFinished(status) {
      return status === CONSTANTS.CONTENT_USER_STATUS.FINISHED
    },
  },
}
</script>
